import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import FormikInput from '../../../../../../CommonComponents/FormikInput';
import { addTelephone } from '../../../../../ExperianActions';
import { Title } from '../../../ReportStyles';
import ExperianContext from '../../../../../ExperianContext';

const TelephoneNumberForm = ({ onCancel, onRequestClose }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        telephoneNumber: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addTelephone(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor Telephone Numbers</Title>
          <Label>
            <LabelText>Telephone Number</LabelText>
            <Field type="text" name="telephoneNumber" component={FormikInput} size="small" />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

TelephoneNumberForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default TelephoneNumberForm;
